import { SliderMark } from './slider_mark';

interface Props {
  marks: SliderMark[];
  max: number;
  step: number;
}

export function SliderMarks({ marks, max, step }: Props) {
  const calculate_tick_index = (value: number, step = 1): number => Math.floor(value / step);

  const calculate_tick_percent = (index: number, max: number, step = 1): number => ((index * step) / max) * 100;

  function render_mark(mark: SliderMark) {
    const percent = calculate_tick_percent(calculate_tick_index(mark.value, step), max, step);

    return (
      <div
        key={mark.value}
        className="absolute flex flex-col top-full -mt-2.5 text-center items-center gap-1 pointer-events-none"
        style={{ left: `${percent}%`, translate: `-${percent}%` }}
      >
        <div className="block h-3 w-3 rounded-full border-2 border-primary bg-background ring-offset-background" />
        <span className="text-sm text-primary">{mark.label}</span>
      </div>
    );
  }

  return marks.map(render_mark);
}
